import { render, staticRenderFns } from "./FieldEditorJS.vue?vue&type=template&id=1cfa3dd5&scoped=true&"
import script from "./FieldEditorJS.vue?vue&type=script&lang=js&"
export * from "./FieldEditorJS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfa3dd5",
  null
  
)

export default component.exports